import { PriceHistoryEntry, PriceHistoryEventType } from 'models/price-request';
import { formatCurrency, formatNumber } from 'utils/format';

const sign = (value: number) => (value > 0 ? '+' : value < 0 ? '−' : '±');

/** "+100.00 SEK · +5.1 %" from the backend's priceDelta and pricePercent (already in percent). */
export const formatPriceDelta = (
    priceDelta: number | null | undefined,
    pricePercent: number | null | undefined,
    currency: string,
): string => {
    if (priceDelta === null || priceDelta === undefined) return '';
    const amount = `${sign(priceDelta)}${formatCurrency(Math.abs(priceDelta), currency)}`;
    if (pricePercent === null || pricePercent === undefined) return amount;
    const percent = `${sign(pricePercent)}${formatNumber(Math.abs(pricePercent), {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    })} %`;
    return `${amount} · ${percent}`;
};

/** Newest first: the timeline reads from today backwards (the API returns oldest first). */
export const newestFirst = (entries: PriceHistoryEntry[]): PriceHistoryEntry[] =>
    entries
        .map((entry, index) => ({ entry, index }))
        .sort((a, b) => {
            const byDate = new Date(b.entry.effectiveAt).getTime() - new Date(a.entry.effectiveAt).getTime();
            return byDate || b.index - a.index;
        })
        .map(({ entry }) => entry);

export const isWithdrawal = (entry: PriceHistoryEntry): boolean => entry.type === PriceHistoryEventType.WITHDRAWN;
